import { render, staticRenderFns } from "./notPurchasedError.vue?vue&type=template&id=2e4c1a04&scoped=true&"
import script from "./notPurchasedError.vue?vue&type=script&lang=js&"
export * from "./notPurchasedError.vue?vue&type=script&lang=js&"
import style0 from "./notPurchasedError.vue?vue&type=style&index=0&id=2e4c1a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c1a04",
  null
  
)

export default component.exports